export default __webpack_public_path__ + "static/media/image2.98221c75.svg";